// REACT & Libraries
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Common/FilterComponent";

// Table
import { BarangayTableColumn } from "../../../../Data/DataTables/AttachmentCategory";

// Types
import { ViewAttachmentCategory } from "../../../../Types/Attachments/AttachmentCategory";

// Services
import {
  VIEW_ATTACHMENT_CATEGORY_QUERY_KEY,
  attachmentCategoryService,
} from "../../../../Services/attachmentCategoryService";

const AttachmentCatgoryTable = () => {
  const [filterText, setFilterText] = useState("");
  const { data: dataResponse, isLoading } = useQuery({
    queryKey: VIEW_ATTACHMENT_CATEGORY_QUERY_KEY,
    queryFn: attachmentCategoryService.getAllAttachmentCategories,
  });

  const filteredItems: ViewAttachmentCategory[] =
    dataResponse?.data.filter((item: ViewAttachmentCategory) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
    ) ?? [];

  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={BarangayTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default AttachmentCatgoryTable;
